/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Damages_EmptyInputs */

const en_case_damages_empty = /** @type {(inputs: Case_Damages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No values added.`)
};

const pt_br2_case_damages_empty = /** @type {(inputs: Case_Damages_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum valor adicionado.`)
};

/**
* | output |
* | --- |
* | "No values added." |
*
* @param {Case_Damages_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_damages_empty = /** @type {((inputs?: Case_Damages_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Damages_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_damages_empty(inputs)
	return pt_br2_case_damages_empty(inputs)
});